import { render, staticRenderFns } from "./NotenerfassungPunkte.vue?vue&type=template&id=5a612a53"
import script from "./NotenerfassungPunkte.vue?vue&type=script&lang=js"
export * from "./NotenerfassungPunkte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports